import $ from "jquery";

/**
 * GF-velden met de `sb_choice-always-checked` css class houden hun E-mail-keuze
 * altijd aangevinkt (contactvoorkeuren lead form v3: e-mail is nodig voor de
 * opvolging van de lead). De keuze wordt aangevinkt + vergrendeld (s_locked →
 * pointer-events: none) en een change-guard vangt toetsenbordinteractie af.
 * Server-side wordt de waarde ook afgedwongen in gf-lead-form-templates.php.
 */

const fieldClass = "sb_choice-always-checked";
const lockedValue = "E-mail";

function isLockedInput(input) {
    return $(input).val() === lockedValue;
}

function lockChoices() {
    $(`.${fieldClass} input[type="checkbox"]`).each(function () {
        if (!isLockedInput(this)) {
            return;
        }

        $(this)
            .prop("checked", true)
            .attr("tabindex", "-1")
            .closest(".gchoice")
            .addClass("s_locked");
    });
}

$(document).on("change", `.${fieldClass} input[type="checkbox"]`, function () {
    if (isLockedInput(this)) {
        $(this).prop("checked", true);
    }
});

$(document).on("gform_post_render", lockChoices);

lockChoices();
